import { api } from './client';

export async function getBillingProfile() {
  return api.get('/billing/profile');
}

export async function createCheckout({ planType }) {
  return api.post('/billing/create-checkout', { plan_type: planType });
}

export async function createPortal() {
  return api.post('/billing/portal');
}

export async function reconcileQuantity() {
  return api.post('/billing/reconcile-quantity');
}

export async function createUpgradeCheckout() {
  return api.post('/billing/create-upgrade-checkout');
}
